import {NgForOf, NgIf} from '@angular/common';
import {Component, Input} from '@angular/core';

export interface FaqSectionItem {
    question: string;
    answer: string;
}

@Component({
    selector: 'app-faq-section',
    standalone: true,
    imports: [
        NgForOf,
        NgIf,
    ],
    templateUrl: './faq-section.component.html',
    styleUrl: './faq-section.component.scss',
})
export class FaqSectionComponent {
    @Input() items: ReadonlyArray<FaqSectionItem> = [];
    @Input() sectionId = 'faq';
    @Input() eyebrow = 'FAQ';
    @Input() title = 'Частые вопросы';
    @Input() description?: string;
    @Input() animated = false;
    @Input() animationDelayStep = 70;
    @Input() animationDelayMax = 210;

    getAnimationDelay(index: number): string | null {
        if (!this.animated) {
            return null;
        }

        return `${Math.min(index * this.animationDelayStep, this.animationDelayMax)}`;
    }
}
